import { JSX } from 'react';
import {
    Edit,
    SimpleForm,
    required,
    SelectInput,
    ReferenceInput,
    TextInput,
    DateInput,
    ImageField,
    ArrayInput,
    SimpleFormIterator,
    DateField
} from 'react-admin';
import {
    Grid,
    Box,
} from '@mui/material';
import { useActiveStatus, contactTypes } from "../../defaults/defaults";
import { ChatFieldBridge } from "../chat-bot/components/ChatFieldBridge";

export const AdminEmployeeEdit: () => JSX.Element = (): JSX.Element => {
    const statuses: { id: string, name: string }[] = useActiveStatus();

    return (
        <Edit >
            <SimpleForm>
                <Grid container spacing={ 2 } sx={ { width: '100%' } }>
                    <Grid size={ 6 }>
                        <TextInput name="name" source="name" validate={[required()]} fullWidth />
                        <SelectInput
                            source="status"
                            choices={ statuses }
                        />
                        <TextInput name="position" source="position" fullWidth />
                        <ReferenceInput
                            label="company"
                            source="company"
                            reference="companies"
                        >
                            <SelectInput optionText="name"/>
                        </ReferenceInput>
                        <TextInput name="telephone" source="telephone" fullWidth />
                        <DateInput source="startDate"  />
                        <DateInput source="endDate"  />
                    </Grid>
                    <Grid size={ 6 }>
                        <TextInput name="email" source="email" validate={[required()]} fullWidth />
                        <TextInput name="department" source="department" fullWidth />
                        <SelectInput name="type" source="type" choices={ contactTypes } fullWidth />
                        <DateInput source="importedDate"  />
                        <DateInput source="FinderDate"  />
                        <ImageField source='avatar.url' />
                        <Box sx={ {
                            width: '100%',
                            height: '400px',
                            overflowY: 'auto'
                        } }>
                            <ArrayInput source="notes" >
                                <SimpleFormIterator disabled>
                                    <TextInput readOnly source="title" />
                                    <TextInput readOnly source="message" />
                                    <TextInput readOnly source="author" />
                                    <TextInput readOnly source="editor" />
                                    <Box sx={ {
                                        display: 'flex',
                                        justifyContent: 'space-between'
                                    } }>
                                        <span>{ "Created" }</span>
                                        <DateField source="id"
                                                   showTime
                                                   transform={ (value: any): Date => {
                                                       return new Date(value * 1000);
                                                   } }
                                        />
                                    </Box>
                                </SimpleFormIterator>
                            </ArrayInput>
                        </Box>
                    </Grid>
                </Grid>
                {/* Offers this form to the assistant. Renders nothing, writes nothing by itself. */}
                <ChatFieldBridge />
            </SimpleForm>
        </Edit>
    );
}